export var EPSILON = 2.220446049250313e-16;

export function swap(A: number[], i0: number, i1: number, t: number) {
	t = A[i0];
	A[i0] = A[i1];
	A[i1] = t;
}

export function hypot(a: number, b: number) {
	a = Math.abs(a);
	b = Math.abs(b);
	if (a > b) {
		b /= a;
		return a * Math.sqrt(1.0 + b * b);
	}
	if (b > 0) {
		a /= b;
		return b * Math.sqrt(1.0 + a * a);
	}
	return 0.0;
}

/**
 * Clamp number within bounds.
 *
 * Applies the upper bound, then the lower bound (matching lodash `clamp`). For a
 * valid range (`low <= high`) the result is `low <= value <= high`; an inverted
 * range (`low > high`) collapses to `low` rather than throwing.
 *
 * @returns The clamped value
 */
export function clamp(value: number, low: number, high: number): number {
	if (value > high) {
		value = high;
	}
	if (value < low) {
		value = low;
	}
	return value;
}

export var Util = {
	swap,
	hypot,
	clamp,
};

export interface Size {
	width: number;
	height: number;
}
